import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_iuf_select = _resolveComponent("iuf-select")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    title: _ctx.t('UPDATE_ASSET_CLASSIFICATION', { asset: _ctx.leadTypeLabel.toLowerCase() }),
    onConfirm: _ctx.validateAndSubmit,
    onCancel: _ctx.cancel,
    loading: _ctx.loading,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "q-pa-lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            greedy: "",
            id: "asset-edition-form",
            ref: "assetEditionForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_input, _mergeProps(_ctx.INPUT_LG, {
                label: _ctx.t('NAME'),
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
              }), null, 16, ["label", "modelValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.developmentPhase,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.developmentPhase) = $event))
              }, _ctx.SELECT_SINGLE_LG_SEARCH, {
                label: _ctx.t('DEVELOPMENT_PHASE'),
                "allow-create": _ctx.canCreateDevelopmentPhase && _ctx.isAllowedForDevPhase,
                options: _ctx.developmentPhaseOptions,
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_SINGLE'),
                "option-label": "label",
                "option-value": "dobjId",
                removable: "",
                "selected-item-slot": "",
                onFilter: _ctx.filterDevelopmentPhaseOptions,
                onCreateValue: _ctx.createDevelopmentPhase
              }), {
                "selected-item": _withCtx((scope) => [
                  _createVNode(_component_q_item_label, { class: "ellipsis" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.opt.label) + " ", 1),
                      _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.opt.label), 1)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 16, ["modelValue", "label", "allow-create", "options", "placeholder-value", "onFilter", "onCreateValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.assetTypes,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.assetTypes) = $event)),
                label: _ctx.t('ASSET_TYPE'),
                options: _ctx.assetTypesOptions
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                "allow-create": _ctx.canCreateAssetType && _ctx.isAllowedForAssetType,
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterAssetTypesOptions,
                "selected-item-slot": "",
                onCreateValue: _ctx.createAssetType
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "allow-create", "placeholder-value", "onFilter", "onCreateValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.mechanismOfActions,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mechanismOfActions) = $event)),
                label: _ctx.t('MECHANISM_OF_ACTION'),
                options: _ctx.mechanismOfActionsOptions
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                "allow-create": _ctx.canCreateMechanismOfActions && _ctx.isAllowedForMechanismOfAction,
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterMOAOptions,
                "selected-item-slot": "",
                onCreateValue: _ctx.createMOA
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "allow-create", "placeholder-value", "onFilter", "onCreateValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.therapeuticAreas,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.therapeuticAreas) = $event))
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                label: _ctx.t('THERAPEUTIC_AREA'),
                options: _ctx.therapeuticAreasOptions,
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterTherapeuticAreasOptions,
                "selected-item-slot": "",
                "allow-create": _ctx.canCreateTherapeuticArea && _ctx.isAllowedForTherapeuticAreas,
                onCreateValue: _ctx.createTherapeuticArea
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "placeholder-value", "onFilter", "allow-create", "onCreateValue"]),
              _createVNode(_component_q_input, _mergeProps({
                label: _ctx.t('THERAPEUTIC_AREA_DETAIL.TITLE'),
                placeholder: _ctx.t('THERAPEUTIC_AREA_DETAIL.TITLE'),
                "input-class": "'text-body1 text-primary-darker'"
              }, _ctx.TEXTAREA_LG, {
                modelValue: _ctx.therapeuticAreaDetail,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.therapeuticAreaDetail) = $event))
              }), null, 16, ["label", "placeholder", "modelValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.clinicalIndications,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.clinicalIndications) = $event))
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                label: _ctx.t('CLINICAL_INDICATION'),
                options: _ctx.clinicalIndicationsOptions,
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterClinicalIndicationsOptions,
                "selected-item-slot": "",
                "allow-create": _ctx.canCreateClinicalIndication && _ctx.isAllowedForClinicalIndication,
                onCreateValue: _ctx.createClinicalIndication
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "placeholder-value", "onFilter", "allow-create", "onCreateValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.technologies,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.technologies) = $event))
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                label: _ctx.t('TECHNOLOGIES'),
                options: _ctx.technologiesOptions,
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterTechnologiesOptions,
                "selected-item-slot": "",
                onCreateValue: _ctx.createTechnology,
                "allow-create": _ctx.canCreateTechnology && _ctx.isAllowedForTechnology
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "placeholder-value", "onFilter", "onCreateValue", "allow-create"]),
              _createVNode(_component_q_input, _mergeProps({
                label: _ctx.t('DESCRIPTION'),
                placeholder: _ctx.t('PLACEHOLDER.DESCRIPTION'),
                "input-class": "'text-body1 text-primary-darker'"
              }, _ctx.TEXTAREA_LG, {
                modelValue: _ctx.description,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.description) = $event))
              }), null, 16, ["label", "placeholder", "modelValue"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "onConfirm", "onCancel", "loading"]))
}